export enum Operation
{
    ADD = 'add',
    REMOVE = 'remove',
    REPLACE = 'replace'
}
